import React from 'react';
import axios from "axios";
import {useParams} from 'react-router-dom';

import en from '../../../locales/en/translation.json';
import fr from '../../../locales/fr/translation.json';

class ActualitesPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: 'en',
            trad: en,
            actu: null,
            slug: this.props.slug,
        }
    }

    componentDidMount() {
        document.querySelector('body').classList.add('actualite_page');
        let url = import.meta.env.VITE_BACKEND_URL + '/actualite/get/' + this.state.slug;
        axios.get(url)
            .then((response) => {
                this.setState({
                    actu: response.data
                },() => {
                    document.title = `${this.state.actu.titre} | Actualité | WonderPlace`;
                })
            }).catch((error) => {
            console.log(error);
        });
    }

    render() {
        const actu = this.state.actu;
        return (
            <>
                {
                    actu &&
                    <div className="actualite_simple">
                        <div className="titre">
                            <h1>{actu.titre}</h1>
                        </div>
                        <div className="actualite-img_simple">
                            <img src={import.meta.env.VITE_BACKEND_URL_IMG + "/uploads/" + actu.image} alt={actu.titre}/>
                        </div>
                        <div className="actualite-text_simple">
                             <div className="body" dangerouslySetInnerHTML={{ __html: actu.contenu }}></div>
                        </div>
                    </div>
                }
            </>
        )
    }
}

export default (props) => {
    const params = useParams();
    return <ActualitesPage {...props} slug={params.slug}/>;
};
